import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {NexioResponse, Payment} from '../../graphql/payments.datatypes';


export interface ValidateSurchargeInput {
    data: {
        billingState: string
        token: string
    }
}

interface ValidateSurchargeData {
    validateSurcharge: NexioResponse
}

export const VALIDATE_SURCHARGE_MUTATION = gql`
    mutation validateSurcharge($data: ValidateSurchargeInput!) {
        validateSurcharge(data: $data) {
            data
        }
    }
`;

export const validateSurcharge = () => useMutation<ValidateSurchargeData, ValidateSurchargeInput>(
    VALIDATE_SURCHARGE_MUTATION,
);

export default validateSurcharge;
